// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1R9Rh","newExpiryDate":"styles_newExpiryDate__2vmn1","footer":"styles_footer__2kCqc"};